import { NgModule, ApplicationRef } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@angular/material";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import "hammerjs";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Layout
import { LayoutComponent } from "./layout/layout.component";
import { PreloaderDirective } from "./layout/preloader.directive";
// Header
import { AppHeaderComponent } from "./layout/header/header.component";
// Sidenav
import { AppSidenavComponent } from "./layout/sidenav/sidenav.component";
import { ToggleOffcanvasNavDirective } from "./layout/sidenav/toggle-offcanvas-nav.directive";
import { AutoCloseMobileNavDirective } from "./layout/sidenav/auto-close-mobile-nav.directive";
import { AppSidenavMenuComponent } from "./layout/sidenav/sidenav-menu/sidenav-menu.component";
import { AccordionNavDirective } from "./layout/sidenav/sidenav-menu/accordion-nav.directive";
import { AppendSubmenuIconDirective } from "./layout/sidenav/sidenav-menu/append-submenu-icon.directive";
import { HighlightActiveItemsDirective } from "./layout/sidenav/sidenav-menu/highlight-active-items.directive";
// Customizer
import { AppCustomizerComponent } from "./layout/customizer/customizer.component";
import { ToggleQuickviewDirective } from "./layout/customizer/toggle-quickview.directive";
// Footer
import { AppFooterComponent } from "./layout/footer/footer.component";
// Search Overaly
import { AppSearchOverlayComponent } from "./layout/search-overlay/search-overlay.component";
import { SearchOverlayDirective } from "./layout/search-overlay/search-overlay.directive";
import { OpenSearchOverlaylDirective } from "./layout/search-overlay/open-search-overlay.directive";

// Pages

import { DashboardComponent } from "./dashboard/dashboard.component";
import { PageLayoutFullscreenComponent } from "./page-layouts/fullscreen/fullscreen.component";
import { DragulaModule } from "ng2-dragula";
import { LoaderComponent } from "./loader/loader.component";
import { LoaderService } from "./loader/loader.service";
import { dialogComponent } from "./dialog/dialog.component";
import { CommonService } from "./shared/services/common.service";
// Sub modules
import { MdDialogModule } from "@angular/material";

import { LayoutModule } from "./layout/layout.module";
import { SharedModule } from "./shared/shared.module";
import { UsersListComponent } from "./users/usersList.component";
import { usersResultService } from "./usersResultService";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { CustomDatePipe } from "./datex.pipe";

// hmr
import { removeNgStyles, createNewHosts } from "@angularclass/hmr";
import { CreateOrUpdateUserComponent } from "./users/createOrUpdateUser.component";
import { ConfigurationsComponent } from "./configurations/configurations.component";
import { ConfigsListComponent } from "./configurations/configsList.component";
import { EmailTemplateListComponent } from "./emailTemplates/emailTemplateList.component";
import { EmailTemplateComponent } from "./emailTemplates/emailTemplate.component";
import { ActivityLogComponent } from "./activityLog/activityLog.component";
import { EditActivityLogComponent } from "./activityLog/editActivityLog.component";
import { FileUploadModule } from "ng2-file-upload";
import { DocumentsComponent } from "./documents/documents.component";
import { ParametersComponent } from "./parameters/parameters.component";
import { SearchComponent } from "./search/search.component";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
// import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import { NgxEditorModule } from 'ngx-editor';
import { CKEditorModule } from "ng2-ckeditor";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TooltipModule } from "ng2-tooltip-directive";
import {
  SocialLoginModule,
  AuthServiceConfig,
  LoginOpt,
} from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { APPCONFIG } from "./config";
import { TokenInterceptor } from "./shared/services/token.interceptor";
// import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { NgxSpinnerModule } from 'ngx-spinner';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const googleLoginOptions: LoginOpt = {
  scope: "profile email",
};

let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      APPCONFIG.google_client_id,
      googleLoginOptions
    ),
  },
]);

export function provideConfig() {
  return config;
}

@NgModule({
  imports: [
    TooltipModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    MdDialogModule,
    FormsModule,
    DragulaModule.forRoot(),
    MaterialModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // InfiniteScrollModule,
    // NgxSpinnerModule,
    ReactiveFormsModule,
    AngularMultiSelectModule,
    // Sub modules
    LayoutModule,
    SharedModule,
    NgxDatatableModule,
    FileUploadModule,
    HttpClientModule,
    CKEditorModule,
    SocialLoginModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    AppComponent,
    CustomDatePipe,
    // Layout
    LayoutComponent,
    PreloaderDirective,
    // Header
    AppHeaderComponent,
    // Sidenav
    AppSidenavComponent,
    ToggleOffcanvasNavDirective,
    AutoCloseMobileNavDirective,
    AppSidenavMenuComponent,
    AccordionNavDirective,
    AppendSubmenuIconDirective,
    HighlightActiveItemsDirective,
    // Customizer
    AppCustomizerComponent,
    ToggleQuickviewDirective,
    // Footer
    AppFooterComponent,
    // Search overlay
    AppSearchOverlayComponent,
    SearchOverlayDirective,
    OpenSearchOverlaylDirective,
    //
    LoaderComponent,
    dialogComponent,

    DashboardComponent,
    UsersListComponent,
    // Pages
    PageLayoutFullscreenComponent,
    CreateOrUpdateUserComponent,
    ConfigurationsComponent,
    ConfigsListComponent,
    EmailTemplateListComponent,
    EmailTemplateComponent,
    ActivityLogComponent,
    DocumentsComponent,
    ParametersComponent,
    SearchComponent,
    EditActivityLogComponent,
  ],
  providers: [
    LoaderService,
    CommonService,
    usersResultService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    //,{provide: UrlSerializer, useClass: LowerCaseUrlSerializer}
  ],
  entryComponents: [dialogComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log("HMR store", store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(
      (cmp) => cmp.location.nativeElement
    );
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts